module.exports = __webpack_public_path__ + "img/cross_country_track.9e6b3706.jpg";